import { TRoutes } from '~/routes/const'
import { routeNames } from '../const'

export default [
  {
    path: routeNames.lotterySetting,
    component: () => import('../../pages/lotterySetting/lotterySetting/list'),
    meta: { title: '中奖设置' }
  }
] as TRoutes[]
